const fundraisingOportunityPhases = [
  {
    title: 'Capital semilla',
    id: 'FOP00',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Capital arranque',
    id: 'FOP01',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Capital expansión',
    id: 'FOP02',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Capital consolidación',
    id: 'FOP03',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Capital internacionalización',
    id: 'FOP04',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Capital reestructuración',
    id: 'FOP05',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Capital refinanciación',
    id: 'FOP06',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Capital adquisiones,MBO, BUYOUT, etc',
    id: 'FOP07',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Capital de trabajo/working capital',
    id: 'FOP08',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Project finance corporativos',
    id: 'FOP09',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Capital mezzanine o puente',
    id: 'FOP10',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Capital distress',
    id: 'FOP11',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Emisiones mercados capital corporativo',
    id: 'FOP12',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Capital privado',
    id: 'FOP13',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Rondas de financiación',
    id: 'FOP14',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Préstamos de inversión a largo plazo',
    id: 'FOP15',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  },
  {
    title: 'Capital de riesgo',
    id: 'FOP16',
    image:
      'https://s3.amazonaws.com/cdn.wp.m4ecnet/wp-content/uploads/2017/09/08053904/Depositphotos_138430266_m-2015-compressor.jpg'
  }
]
export default fundraisingOportunityPhases
